import { Recording, TotalEarnings } from '@solo/app-core';
import { translate } from '@/app/i18n';
import { RouterLink, Text } from '@/app/ui/atoms';
import { RecordingWithEarnings } from '@/app/ui/organisms/Royalties/TopEarningWorks';
import { Table } from '@/app/ui/molecules';
import Colors from '@/app/styles/Colors';

interface TopEarningWorksListProps {
  earningsData: RecordingWithEarnings[];
}

const MOCK_EARNINGS_DATA: RecordingWithEarnings[] = [
  {
    recording: {
      title: 'Catch This Train',
      artistName: 'Soweto',
    } as Recording,
    earnings: { recordingId: 'aa1', publishing: 2, distribution: 2.5, total: 4.5 } as TotalEarnings,
  },
  {
    recording: {
      title: 'Roseita',
      artistName: 'Soweto',
    } as Recording,
    earnings: { recordingId: 'aa2', publishing: 3, distribution: 2.5, total: 5.5 } as TotalEarnings,
  },
  {
    recording: {
      title: 'Look Around',
      artistName: 'Soweto',
    } as Recording,
    earnings: {
      recordingId: 'aa3',
      publishing: 2,
      distribution: 2.75,
      total: 4.75,
    } as TotalEarnings,
  },
  {
    recording: {
      title: 'Catch This Train',
      artistName: 'Soweto',
    } as Recording,
    earnings: { recordingId: 'aa4', publishing: 3, distribution: 3.5, total: 6.5 } as TotalEarnings,
  },
  {
    recording: {
      title: 'Roseita',
      artistName: 'Soweto',
    } as Recording,
    earnings: {
      recordingId: 'aa5',
      publishing: 4,
      distribution: 3.25,
      total: 7.25,
    } as TotalEarnings,
  },
];

const EarningWorksList = ({ earningsData }: TopEarningWorksListProps) => {
  const data = earningsData.length ? earningsData : MOCK_EARNINGS_DATA;

  return (
    <Table.Container flexDirection="column">
      <Table.Thead gap="16px">
        <Table.Th flex={4} padding="0 0 0 1rem">
          <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
            {translate('WORKS.TITLE')}
          </Text.Paragraph>
        </Table.Th>
        <Table.Th flex={4}>
          <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
            {translate('WORKS.ARTIST')}
          </Text.Paragraph>
        </Table.Th>
        <Table.Th flex={2}>
          <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
            {translate('EARNINGS.PUBLISHING')}
          </Text.Paragraph>
        </Table.Th>
        <Table.Th flex={2}>
          <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
            {translate('EARNINGS.DIGITAL_DISTRIBUTION')}
          </Text.Paragraph>
        </Table.Th>
        <Table.Th flex={1}>
          <Text.Paragraph fontWeight={600} style={{ padding: 0 }}>
            {translate('EARNINGS.TOTAL')}
          </Text.Paragraph>
        </Table.Th>
      </Table.Thead>
      <Table.Tbody flexDirection="column">
        {data.map((earningData) => (
          <Table.Tr key={earningData.earnings.recordingId} alignItems="center" gap="16px">
            <Table.Td flex={4} padding="0 0 0 1rem">
              {earningData.recording.id ? (
                <RouterLink
                  $transparent
                  $variant="primary"
                  to={`/works/${earningData.recording.id}/tracks/${earningData.recording.id}`}
                >
                  <Text.Paragraph fontWeight={600}>{earningData.recording.title}</Text.Paragraph>
                </RouterLink>
              ) : (
                <Text.Paragraph color={Colors.primary} fontWeight={600}>
                  {earningData.recording.title}
                </Text.Paragraph>
              )}
            </Table.Td>
            <Table.Td flex={4}>{earningData.recording.artistName}</Table.Td>
            <Table.Td flex={2}>{earningData.earnings.publishing}€</Table.Td>
            <Table.Td flex={2}>{earningData.earnings.distribution}€</Table.Td>
            <Table.Td flex={1}>{earningData.earnings.total}€</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table.Container>
  );
};

export default EarningWorksList;
